import React, { useState } from "react";
import { AnimatePresence, motion, PanInfo } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, XIcon, CheckIcon } from "lucide-react";
import { premium } from "../data/salesCopy";
import { SectionHeader } from "./SectionHeader";
export function PremiumCompare() {
  const [index, setIndex] = useState(0);
  const [showWith, setShowWith] = useState(false);
  const total = premium.slides.length;
  const slide = premium.slides[index];
  const go = (dir: number) => {
    setIndex(i => (i + dir + total) % total);
    setShowWith(false);
  };
  const onDragEnd = (_: unknown, info: PanInfo) => {
    if (info.offset.x < -50) go(1);else if (info.offset.x > 50) go(-1);
  };
  return <section className="mx-auto max-w-5xl px-5 py-9 md:py-16" data-id="element-186" data-mp="234pnre2njnab">
      <SectionHeader title={premium.eyebrow} subtitle={premium.subtitle} data-id="element-187" data-mp="wp5mcr55y96l" />

      <div className="mt-5 overflow-hidden rounded-2xl bg-card ring-1 ring-line md:mt-10 md:rounded-3xl" data-id="element-188" data-mp="wn2l1ayk8tmk">
        <AnimatePresence mode="wait" initial={false} data-id="element-189" data-mp="30od3pn8fz4tw">
          <motion.div key={index} initial={{
          opacity: 0,
          x: 16
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -16
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.15} onDragEnd={onDragEnd} className="cursor-grab p-4 active:cursor-grabbing md:p-8" data-id="element-190" data-mp="30po4rfai5yhb">
            <span className="text-xs font-bold tabular-nums text-muted" data-id="element-191" data-mp="2lrm3xcuuvr3r">
              {String(index + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
            </span>
            <h3 className="mt-1 font-display text-xl font-bold md:text-2xl" data-id="element-192" data-mp="2cys8a4v3qf3q">{slide.title}</h3>
            <p className="text-sm text-muted md:text-base" data-id="element-193" data-mp="2cwehw9bd9r2i">{slide.problem}</p>

            {/* Mobile: tap to flip between before / after */}
            <button type="button" onClick={() => setShowWith(v => !v)} aria-label={showWith ? "Ver sin Premium" : "Ver con Premium"} className={`mt-3 block w-full rounded-xl p-4 text-left transition-colors duration-200 ease-out md:hidden ${showWith ? "bg-chalk text-white" : "bg-coral-soft"}`} data-id="element-194" data-mp="22zjh1jrmfel2">
              <span className={`flex items-center gap-2 text-xs font-bold ${showWith ? "text-pencil" : "text-coral"}`} data-id="element-195" data-mp="1573atrkqs937">
                {showWith ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="22tsleptifu0o" /> : <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-197" data-mp="22shg2lkf2e7g" />}
                {showWith ? "Con Premium" : "Sin Premium"}
              </span>
              <span className="mt-1.5 block text-sm" data-id="element-198" data-mp="1svmm8fz391zi">{showWith ? slide.with : slide.without}</span>
              <span className={`mt-2 block text-xs font-bold ${showWith ? "text-white/70" : "text-chalk"}`} data-id="element-199" data-mp="1nwjgetbaarqh">
                {showWith ? "Tocá para volver" : "Tocá para ver con Premium →"}
              </span>
            </button>

            <div className="mt-6 hidden gap-4 md:grid md:grid-cols-2" data-id="element-200" data-mp="ch36puy2f01e">
              <div className="rounded-2xl bg-coral-soft p-5" data-id="element-201" data-mp="2o6sy39p5mgd0">
                <p className="flex items-center gap-2 text-sm font-bold text-coral" data-id="element-202" data-mp="2t4kxeos4p4r8"><XIcon className="h-4 w-4" aria-hidden="true" data-id="element-203" data-mp="2t2rpl65s4ehn" />Sin Premium</p>
                <p className="mt-2" data-id="element-204" data-mp="2y2coxhov2ouw">{slide.without}</p>
              </div>
              <div className="rounded-2xl bg-chalk p-5 text-white" data-id="element-205" data-mp="32uxeu84ncht5">
                <p className="flex items-center gap-2 text-sm font-bold text-pencil" data-id="element-206" data-mp="37tqtw4zl0gvf"><CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="37th52kq9wfrb" />Con Premium</p>
                <p className="mt-2" data-id="element-208" data-mp="3bu12zqio7nei">{slide.with}</p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="flex items-center justify-between border-t border-line px-4 py-3 md:px-8" data-id="element-209" data-mp="3gsm2fnq3m31w">
          <button type="button" onClick={() => go(-1)} aria-label="Anterior" className="rounded-full p-1.5 ring-1 ring-line transition-colors duration-150 ease-out hover:bg-paper" data-id="element-210" data-mp="3lr5nzn0s5ctq">
            <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="1rfqv4xch2x9r" />
          </button>
          <div className="flex gap-1.5" data-id="element-212" data-mp="3hv1dbq5e2dn5">
            {premium.slides.map((s, i) => <button key={s.title} type="button" onClick={() => {
            setIndex(i);
            setShowWith(false);
          }} aria-label={`Ver ${s.title}`} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? "w-5 bg-chalk" : "w-1.5 bg-line"}`} data-id="element-213" data-mp="3cwq0r7nplp18" data-mpi={i} />)}
          </div>
          <button type="button" onClick={() => go(1)} aria-label="Siguiente" className="rounded-full p-1.5 ring-1 ring-line transition-colors duration-150 ease-out hover:bg-paper" data-id="element-214" data-mp="2u8b7setu00xs">
            <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-215" data-mp="336na3e428n62" />
          </button>
        </div>
      </div>

      <h3 className="mt-6 text-xs font-bold tracking-wide text-chalk md:mt-12 md:text-sm" data-id="element-216" data-mp="2fgsx8wjqqylt">{premium.includesTitle}</h3>
      <ul className="mt-3 grid gap-3 sm:grid-cols-2 md:mt-4 md:gap-5" data-id="element-217" data-mp="2bga511dxrqj3">
        {premium.includes.map(p => <li key={p.code} className="flex items-center gap-3 rounded-xl bg-coral-soft p-3 md:items-start md:gap-4 md:bg-transparent md:p-0 md:pt-5" data-id="element-218" data-mp="21aioih2b5hse">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-coral text-sm font-bold text-white md:h-11 md:w-11 md:rounded-xl" data-id="element-219" data-mp="1rfgwndgne1m4">{p.code}</span>
            <div data-id="element-220" data-mp="2k3crsdqkjlgs">
              <p className="text-sm font-bold md:text-lg" data-id="element-221" data-mp="2k2tl5t6dcji2">{p.title}</p>
              <p className="text-xs text-muted md:text-base" data-id="element-222" data-mp="2p262xzidv0ds">{p.text}</p>
            </div>
          </li>)}
      </ul>
    </section>;
}